export default {
  isLogin: state => {
    return !!state.user && !!state.sessionToken
  },
  isShowExchangeCount: state => {
    return state.isShowExchange
  },
}
